import { render, staticRenderFns } from "./PropertiesTable.vue?vue&type=template&id=3377f596&scoped=true"
import script from "./PropertiesTable.vue?vue&type=script&lang=js"
export * from "./PropertiesTable.vue?vue&type=script&lang=js"
import style0 from "./PropertiesTable.vue?vue&type=style&index=0&id=3377f596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3377f596",
  null
  
)

export default component.exports